import { Main } from "@pages/index";
import React from "react";
export const viewMap = {
  home: <Main />,
};
